import { Directive, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";
import { switchMap, takeUntil } from "rxjs/operators";
import { OrganizationLevel } from "src/app/models/organizationLevel.model";
import { TenantSensor } from "src/app/models/tenantSensor.model";
import { OrganizationLevelService } from "src/app/services/organizationLevel.service";

// The tenant sensor create and edit dialogs share this: org levels belong to one tenant, so the
// picker lists the selected tenant's levels, and a new tenant needs a new pick from its own levels.
@Directive()
export abstract class TenantSensorOrgLevelDialogBase implements OnDestroy {
    abstract sensor: TenantSensor;
    orgLevelOptions: OrganizationLevel[] = [];
    protected readonly destroy$ = new Subject<void>();
    private readonly tenantChange$ = new Subject<string>();

    constructor(organizationLevelService: OrganizationLevelService) {
        this.tenantChange$
            .pipe(
                switchMap((tenantId) => organizationLevelService.getTenantTree(tenantId)),
                takeUntil(this.destroy$),
            )
            .subscribe({ next: (levels) => (this.orgLevelOptions = levels) });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onTenantChange(tenantId: string) {
        this.sensor.organizationLevelId = undefined;
        this.orgLevelOptions = [];
        this.loadOrgLevels(tenantId);
    }

    onOrganizationLevelChange(organizationLevelId: string | null) {
        this.sensor.organizationLevelId = organizationLevelId ?? undefined;
    }

    protected loadOrgLevels(tenantId: string) {
        this.tenantChange$.next(tenantId);
    }
}
